// import React, { useState, useEffect } from "react";
// import {
//   Button,
//   FormFieldSet,
//   useFormHandler,
// } from "../../../../../components";

// const BillingAddress = () => {
//   const [validationRules, setValidationRules] = useState({});
//   const [disabled, setDisabled] = useState(true);
//   const [buttonText, setButtonText] = useState("Edit");
//   const initialFormData = {
//     companyName: "",
//     displayName: "",
//     website: "",
//     companyContact: "",
//     panNumber: "",
//     description: "",
//   };
//   const { formData, errors, handleChange, validateAllFields, setFormData } =
//     useFormHandler(initialFormData, validationRules);

//   const handleSubmit = async () => {
//     const isValid = await validateAllFields();
//   };

//   useEffect(() => {
//     const baseRules = {
//       companyName: {
//         type: "text",
//         required: true,
//       },
//       displayName: {
//         type: "text",
//         required: true,
//       },
//       website: {
//         type: "text",
//         required: true,
//       },
//       companyContact: {
//         type: "text",
//         required: true,
//       },
//       panNumber: {
//         type: "text",
//         required: true,
//       },
//     };
//     setValidationRules(baseRules);
//   }, []);

//   const handleButtonClick = () => {
//     if (disabled) {
//       setDisabled(false);
//       setButtonText("Save");
//     } else {
//       handleSubmit();
//       setDisabled(true);
//       setButtonText("Edit");
//     }
//   };

//   return (
//     <div className="flex flex-col justify-between h-150 p-4">
//       <div className="mr-40 grid grid-cols-3 gap-x-4 gap-y-5">
//         <FormFieldSet
//           label="Input"
//           title="Company Name"
//           type="text"
//           placeholder="Enter Company Name"
//           disabled={disabled}
//           value={formData.companyName}
//           onChange={(value) => handleChange("companyName", value)}
//           error={errors.companyName}
//         />
//         <FormFieldSet
//           label="Input"
//           title="Display Name"
//           type="text"
//           placeholder="Enter Display Name"
//           disabled={disabled}
//           value={formData.displayName}
//           onChange={(value) => handleChange("displayName", value)}
//           error={errors.displayName}
//         />
//         <FormFieldSet
//           label="Input"
//           title="Website"
//           type="text"
//           placeholder="Enter Website URL"
//           disabled={disabled}
//           value={formData.website}
//           onChange={(value) => handleChange("website", value)}
//           error={errors.website}
//         />
//         <FormFieldSet
//           label="Input"
//           title="Company Contact"
//           type="text"
//           placeholder="Enter Company Contact"
//           disabled={disabled}
//           value={formData.companyContact}
//           onChange={(value) => handleChange("companyContact", value)}
//           error={errors.companyContact}
//         />
//         <FormFieldSet
//           label="Input"
//           title="PAN Number"
//           type="text"
//           placeholder="Enter PAN Number"
//           disabled={disabled}
//           value={formData.panNumber}
//           onChange={(value) => handleChange("panNumber", value)}
//           error={errors.panNumber}
//         />
//         <div className="col-span-2">
//           <FormFieldSet
//             label="Input"
//             title="Description"
//             type="textArea"
//             placeholder="Enter Description"
//             disabled={disabled}
//             value={formData.description}
//             onChange={(value) => handleChange("description", value)}
//           />
//         </div>
//       </div>
//       <div className="self-end mr-40">
//         <Button type="button" title={buttonText} onClick={handleButtonClick} />
//       </div>
//     </div>
//   );
// };

// export default BillingAddress;

import React from "react";
import { VerticalTabs } from "../../../../../components";
import { useModuleAccess } from "../../../../../hooks";
import Transactions from "./BillingSubscriptionTabs/Transactions";
import PaymentMethods from "./BillingSubscriptionTabs/PaymentMethods";
import Subscriptions from "./BillingSubscriptionTabs/Subscriptions";
import CompanyInfo from "./BillingSubscriptionTabs/CompanyInfo";
import { getItem } from "../../../../../utils/localStorageUtils";

const BillingAddress = () => {
  const portal = getItem("portal");
  const tabList = [
    {
      title: "Subscription",
      id: "reports_ats_rareport",
      page: <Subscriptions />,
    },
    {
      title: "Company Info",
      id: "reports_ats_bdmreport",
      page: <CompanyInfo />,
    },
    {
      title: "Payment Methods",
      id: "reports_ats_recruitmentreport",

      page: <PaymentMethods />,
    },
    {
      title: "Transactions",
      id: "reports_ats_ownershipreport",
      page: <Transactions />,
    },
  ];
  const filteredTabs = useModuleAccess({
    allTabs: tabList,
    parentId: "reports_ats",
    accessKey:
      portal === "bs" ? "benchsales" : portal === "wf" ? "workforce" : "ats",
  });
  return (
    <div className="flex flex-col flex-1 my-2 overflow-auto">
      <VerticalTabs
        tabs={filteredTabs}
        activeColor="primary"
        activeVariant="contained"
      />
    </div>
  );
};

export default BillingAddress;
